export default defineNuxtPlugin(() => {
  const kissmetrics = useKissmetrics()

  return {
    provide: { kissmetrics }
  }
})
